export const environment = {
    oktaConfig: {
        issuer: 'https://ea.okta.com/oauth2/default',
        clientId: '0oasds43d0pJsZcaF0x7', //'0oawwgv9s9wrh30wb0h7',
        audience: 'api://default',
        disableHTTPsCheck: false
    },
    serviceUrl: 'https://companystore-service.eex.ea.com'
};